var validPeriods = [
    { start: new Date(2025,0,1), end: new Date(2025,11, 31)},
    { start: new Date(2026,0,1), end: new Date(2026,7, 1)},
    { start: new Date(2026,7,22), end: new Date(2026,11, 31)}
];
export default validPeriods;

